import { render } from "./DeliveryIndex.vue?vue&type=template&id=0e52d227&scoped=true"
import script from "./DeliveryIndex.vue?vue&type=script&lang=js"
export * from "./DeliveryIndex.vue?vue&type=script&lang=js"

import "./DeliveryIndex.vue?vue&type=style&index=0&id=0e52d227&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e52d227"]])

export default __exports__